import { Button, Card, Stack, Typography } from '@mui/material';
import ROUTES from 'constants/routes';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { $user } from 'store/user/model';

const AssesmentAccessCard = () => {
  const navigate = useNavigate();
  const [me] = useUnit([$user]);
  const { t } = useTranslation();

  console.log('me', me);

  const handleClick = () => {
    navigate(ROUTES.ASSESSMENT, { replace: true });
  };

  return (
    <Card sx={{ maxWidth: 976, textAlign: 'center', marginX: 'auto' }}>
      <Stack spacing={4} alignItems='center'>
        <Stack spacing={1}>
          <Typography variant='h28'>{t('assessment.accessCard.completed')}</Typography>
          <Typography variant='h20'>{t('assessment.accessCard.contactAdmin')}</Typography>
        </Stack>
        {!!me && (
          <Button onClick={handleClick} variant='outlined'>
            {t('header.assessments')}
          </Button>
        )}
      </Stack>
    </Card>
  );
};

export default AssesmentAccessCard;
